import { Comment } from "../../src/components/insta/interfaces";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";


export function getAlexComments(imageKey: string) {

    return alexComments;
}

const alexComments: { [key: string]: (Comment)[]; } = {
    "Alex47": [
        {
            name: alex.properties.instaNickName,
            message: `First time going for a night swim!!! 🥰😍😍 
I recommend it to everyone 👌
just don't get caught 😜`
        },
        {
            name: `slowcum_joe`,
            message: `Ermahgerd! Tern lerns!`
        },
        {
            name: `Terrible_TM`,
            message: `love seeing you wet at night, Alex!`
        },
        {
            name: `dinesh`,
            message: `oh helo prety lady! i put my lulla in you!`
        },
        {
            name: `shah`,
            message: `sit on my dick if you don't want to talk to me 🍆`
        },
        {
            name: `Paximus`,
            message: `I'd catch you`
        },
        {
            name: `dinesh`,
            message: `bich riply me`
        },
        {
            name: `FineBritTea`,
            message: `So elegent with a string of pearls around your neck, darling. I hope your aquatic evening constitutional was invigorating.`
        },
        {
            name: `the_feet_guy`,
            message: `ayo baby... lemme see them lower digits`
        },
        {
            name: `FineBritTea`,
            message: `Show some class Dinesh, there is no need for such coarse vulgarity`
        },
        {
            name: `dinesh`,
            message: `finebrittea u shut fuk up and drnk ur shitty tea u britesh basterd`
        },
        {
            name: `KillianB`,
            message: `Ur so gd hawt bb!!! Luv it!`
        },
        {
            name: `FineBritTea`,
            message: `Dinesh, you are a scoundrel sir. And a cad.`
        },
        {
            name: `Prowl`,
            message: `Freeze! Young lady I'm going to need you to get your hands up.`
        },
        {
            name: `Suricat`,
            message: `I'mma need to lick you dry...`
        },
        {
            name: `Dr.Pancakes`,
            message: `Its dangerous to swim alone, take this 🍆`
        },
        {
            name: `Arthur`,
            message: `omg again Shah and Dinesh two primitive brutes... go back to ZOO! Alex, darling, I could hold your towel, let me know next time you're going to swim. 💗`
        },
        {
            name: `JeanB`,
            message: `Ready for some swimming lessons Babe? We will start with some stretching and take it from there 😏`
        },
        {
            name: `Spiderman`,
            message: `holy smeckles. You are my all time favorite girl`
        },
        {
            name: `Tern`,
            message: `Just getting more and more lewd with the posts, I love it!!!`
        },
        {
            name: `Berlichingen`,
            message: `Whoever caught you on camera is both one lucky bastard and my personal hero! 📸`
        },
        {
            name: `FishtankLifeguard`,
            message: `Even if you can't swim, I bet you won't drown with these big boobs!`
        },
        {
            name: `Sarcasmo`,
            message: `that’s a nice pearl necklace, although not as uh ‘organic’ as your fans would of liked`
        },
        {
            name: `lilgudannie`,
            message: `um ackshually all pearls are organic`
        },
        {
            name: `Sarcasmo`,
            message: `Perhaps organic if not imitation pearls. Taking a pearl and running it along the biting edge of your teeth is the pearl tooth test. The pearl should feel grainy if it is natural. A synthetic pearl will have a smooth, slick feel. Any volunteers to nibble on Alex’s décolletage?`
        },
        {
            name: `Connoisseur`,
            message: `I volunteer to try if her nipples are organic. 😉 Not with teeth ofc,  just with tongue... 😋`
        },
        {
            name: `MCManmaan`,
            message: `Free the Nipple!`
        },

    ],
    "Alex46": [
        {
            name: alex.properties.instaNickName,
            message: `I can't believe I almost got caught doing that 🤭
But it wasn't my idea this time 😉
.
.
btw the food is out of this world!`
        },
        {
            name: `dinesh`,
            message: `open cloth`
        },
        {
            name: `shah`,
            message: `hapy bob uncover!`
        },
        {
            name: `getoutofmylab`,
            message: `🔥 Wow, absolutely stunning!`
        },
        {
            name: `biagra`,
            message: `I feel something growing`
        },
        {
            name: `jimbob_69`,
            message: `Slaying it as always! 😍`
        },
        {
            name: `chris_slayer`,
            message: `Bringing the heat! 🔥😍`
        },
        {
            name: `Erosenin`,
            message: `WOW your date is so lucky! We know why you picked that dress 😜`
        },
        {
            name: `Jasper`,
            message: `Might have? I'm pretty sure you gave the waiter free show. Good for him.`
        },
        {
            name: `Dr.Pancakes`,
            message: `If this was you boyfriends idea, he's a genius. If it wasn't your boyfriends idea and you need more. DM me.  😜`
        },
        {
            name: `simpl_dan42`,
            message: `If that's the show what was for dessert?`
        },
        {
            name: `anns_stalker24`,
            message: `I wish Ann was more like this`
        },
        {
            name: `McManmaan`,
            message: `Does steak pare well with milk; because, Mommy 😚 😚 😚 🍼`
        },
        {
            name: `Prowl`,
            message: `What part of the menu are those on? I would like to order two please and a side of thighs.`
        },
        {
            name: `Sarcasmo`,
            message: `How can you signal to the waiter for dessert if your hands are full? <a:dogwink:932729221866995834>`
        },
        {
            name: `JeanB`,
            message: `God you're distracting girl, trying to eat here! 🥰`
        },
        {
            name: `Spiderman`,
            message: `no way I missed that irl?! I'm sitting right behind you 😥`
        },
        {
            name: `Tern`,
            message: `sigh... * unzips*`
        },

    ],
    "Alex45": [
        {
            name: alex.properties.instaNickName,
            message: `Taking inappropriate photos as a fancy restaurant 🤭
.
.
you have no idea how good the food is! 🤯`
        },
        {
            name: `dinesh`,
            message: `hey prty ldy cook diner for meee`
        },
        {
            name: `shah`,
            message: `I drool 4 u gimme sax bby`
        },
        {
            name: `boomboom`,
            message: `Absolutely mesmerizing! Can’t look away! 😍`
        },
        {
            name: `chris_slayer`,
            message: `Always with that tongue out 😜`
        },
        {
            name: `Erosenin`,
            message: `That dress doesn't leave much to the imagination 😍 Your date a better person than me, I'd be using that easy access 😜`
        },
        {
            name: `Jasper`,
            message: `Damn, girl, if that's what you wear for a date, I pity your boyfriend.`
        },
        {
            name: `Dr.Pancakes`,
            message: `The food there may be good, but I would say you by far are the best dish. 😜`
        },
        {
            name: `McManmaan`,
            message: `Wow a lady of class and elegance? Your BF is a lucky man... And for that reason, I hate him.`
        },
        {
            name: `Prowl`,
            message: `that bowl is really clean... You licked it didn't you? I love a woman that cleans up after a filling meal.`
        },
        {
            name: `Sarcasmo`,
            message: `I'm more interested in that glowing red drink, or is that a candle?`
        },
        {
            name: `JeanB`,
            message: `Hey beauty, now that you had your meal how about some dessert? 😏`
        },
        {
            name: `Arthur`,
            message: `Darling why do you hang out with brutes? I would definitely borrow you my shirt to help you cover yourself. 🤔`
        },
        {
            name: `Spiderman`,
            message: `god damn girl. You are seriously my second favourite girl on Instagram after @isabelditlevsen 🤤`
        },
        {
            name: `Tern`,
            message: `The food might be good and all but something tells me its a bit cold in that restaurant.`
        },

    ],
    "Alex44": [
        {
            name: alex.properties.instaNickName,
            message: `I love bowling!!!
The only balls I played with recently 😜😜😜😜😜`
        },
        {
            name: `jercass`,
            message: `I wonder how the bowling venue allowed it. This is borderline public indecency. Did you rent the entire place for the photo shoot?`
        },
        {
            name: `snicker`,
            message: `I have some balls you can practice with.`
        },
        {
            name: `ferk`,
            message: `You didn't have to go bowling to play with some balls
        Would gladly help you out next time 😏`
        },
        {
            name: `McManmaan`,
            message: `You look like your pretty "handy" with holding heavy things. I could use your help with something.`
        },
        {
            name: `Prowl`,
            message: `You do know your fingers go in the holes right?`
        },
        {
            name: `Spiderman`,
            message: `damn girl. Do you use the lighter balls or are you more of a heavy balls kinda girl?`
        },
        {
            name: `Arthur`,
            message: `Alex it is a bit indecent. Ones like Shah will totally not get it, but I'm sure it was just some fooling around with Annie. Right? You would not do that with a man there. Right? 👀`
        },
        {
            name: `JeanB`,
            message: `wow girl, that are some perfect shape, round, bubbly "balls" you got there. Would you mind if I play with those? 😘`
        },
        {
            name: `davidt`,
            message: `well you know what they say 'practice makes perfect' 😉`
        },
        {
            name: `Magnus`,
            message: `I could teach you another game with my balls. It is played without hands and there's always a reward if you play it right. 😏`
        },
        {
            name: `tern`,
            message: `Remember to clean the balls thoroughly when you are finished with them 😏`
        },
        {
            name: `Adog`,
            message: `Nothing i love more than Bowling and Peaches 🍑`
        },
        {
            name: `CorprealFale`,
            message: `I've got some balls for you to play with! As long as you've got a tennis racket! 😉`
        },

    ],
    "Alex43": [
        {
            name: alex.properties.instaNickName,
            message: `Someone special convinced me to post it 😍😍😍No smile this time, I'm a serious girl! 😉 
            .
            .
            .
            .
            You can't really see the entire nipple so I don't think I'll get banned 🤔`
        },
        {
            name: `Prowl`,
            message: `I think, you could show even more 😜If they try to ban you, we'll just riot.`
        },
        {
            name: `Spiderman`,
            message: `you won't get banned 🚫 I've seen girls on Instagram with see`
        },
        {
            name: `Mysterio`,
            message: `@lynetmcqueen look! 🥵`
        },
        {
            name: `Lynetmcqueen`,
            message: `daaamn @Mysterio.. really hope she will open an OnlyFans soon.`
        },
        {
            name: `Tern`,
            message: `Many would pay good money to see more of your gorgeous body, you could get rich, think about it 💰🤑`
        },
        {
            name: `Tern`,
            message: `And if you are worried about getting banned so are there other platforms around that allow more 😏`
        },
        {
            name: `Arthur`,
            message: `Someone special? 🤔  Your bestie Annie, right? The one you met on your way to pool? right? ....there's no guy, RIGHT??? Annie is such a sweet girl. 🥰  And so are you! ❤️`
        },
        {
            name: `Explorer`,
            message: `damn girl those are some nice fun bags.... do you like motorboating? 😏`
        },
        {
            name: `Magnus`,
            message: `I can think of one thing on your face besides your smile that would make you even more beautiful. 😋`
        },
        {
            name: `Connoisseur`,
            message: `I agree with @Lynetmcqueen and @Tern. Tell that "someone special" there are other sites out there which would not limit your options to express yourself. Also it could open the world of new possibilities...`
        },
        {
            name: `JeanB`,
            message: `you're serious, so will I be: You're gorgeous, mesmerizing, sexy, stunning, captivating, irresitible, breathtaking, wonderful, fantastic, ravishing, glamorous, magnificent and amazingly beautiful girl 💗 😍 ❤️‍🔥❤️`
        }, {
            name: `dinesh`,
            message: `hello deer`
        },
        {
            name: `dinesh`,
            message: `saw nippal`
        },
        {
            name: `shah`,
            message: `hi beuatifull u hav bf?`
        },
        {
            name: `dinesh`,
            message: `wanna frnd?`
        },
        {
            name: `shah`,
            message: `pls sax bby`
        },
        {
            name: `Chandler`,
            message: `Viva Nepal!`
        },
        {
            name: `Arthur`,
            message: `Oh "Great"! Shah is here again 🤨`
        },
        {
            name: `FGB`,
            message: `Titty all day every day!`
        },
        {
            name: `ferk`,
            message: `Everyone's talking about the wrong thing here! Those are some sexy legs! 🔥`
        },
        {
            name: `rem`,
            message: `and so starts the downfall. Girl, you still have a few years to sell bathwater before you undress completely. The only way further is down.`
        },
        {
            name: `Trop`,
            message: `you're teasing me....show the nipple please!....i'll die if i don't see it!!! 😰`
        },
        {
            name: `war`,
            message: `See, everyone loves it.`
        },
        {
            name: `Sarcasmo`,
            message: `No wonder it doesn’t fit, the mesh pantyhose is meant to go over your legs, not over your arms`
        },

    ],
    "Alex42": [
        {
            name: alex.properties.instaNickName,
            message: `Don't mind me just doing some shopping 😍😜😜🛍️`
        },
        {
            name: `Prowl`,
            message: `If you take me with you, I'll carry all your bags and help you pick things out.`
        },
        {
            name: `McManmaan`,
            message: `There is not enough money in my wallet to pay for everything I would buy you... Good thing I have credit cards! 🍑`
        },
        {
            name: `CorprealFale`,
            message: `Need style advice? I'm sure we can find a better color match! 😍`
        },
        {
            name: `xXxNaruto1xXx`,
            message: `Gorgeius! Mrry babe!`
        },
        {
            name: `Suricat`,
            message: `we'll need the pics to help you pick the clothes ! 😘`
        },
        {
            name: `JeanB`,
            message: `I hope you picked something nice for our date, looking forward to it. 😉\nIf not that's OK too. You'll look even better without clothes 🥰❤️‍🔥`
        },
        {
            name: `Arthur`,
            message: `Alex did you drop something? 🧐  Your skirt is too short, you should be more careful next time.`
        },
        {
            name: `Spiderman`,
            message: `never noticed your tounge piercing. That's pretty hot, Alex!`
        },
        {
            name: `davidt`,
            message: `whoever took this pic is so damn lucky!`
        },
        {
            name: `Harry`,
            message: `Who is taking that pic??`
        },
        {
            name: `tern`,
            message: `Such a tease! 🥵  Mind giving a little show of what you bought?`
        },
        {
            name: `Adog`,
            message: `GYAT DAYUM! Girl looking thicker than a bowl of oatmeal`
        },

    ],
    "Alex41": [
        {
            name: alex.properties.instaNickName,
            message: `after shower selfieeeeee 🔥🔥🔥🔥
            clothes are overrated anywaysssss 😘 🚿`,
        },
        {
            name: `Prowl`,
            message: `Mmm I like it when you're all wet. 😏`
        },
        {
            name: `getoutofmylab`,
            message: `uncover oppai!`
        },
        {
            name: `Sarcasmo`,
            message: `I think it’s a ruse; you are body blocking the real reason for that puddle and your sweatiness 😉`
        },
        {
            name: `Dr.Pancakes`,
            message: `You know what else is overrated? Solo showers; I hear that group showers are all the rage right now. 😜`
        },
        {
            name: `CorprealFale`,
            message: `The hand is in the way!`
        },
        {
            name: `Spiderman`,
            message: `Is that an ahegao? Oh Alex.. You naughty, naughty girl...`
        },
        {
            name: `ruff_ryder`,
            message: `Not the best ahegao but I'll take it.`
        },
        {
            name: `erosennin`,
            message: `sigh, I'll be in my bunk`
        },



    ],
    "Alex40": [
        {
            name: alex.properties.instaNickName,
            message: `Working from homeeeee! 💋💋💋\nI have this weird talent taking horizontal photos while holding my phone vertical 😊\n'\n'\n'\nalso hide de nipples!\nI hope I don't get banned 🙏🙏🙏" #sun #nude #sexy #selfie #tease`,
        },
        {
            name: `GetOutOfMyLab`,
            message: `@${alex.properties.instaNickName} how much do you love exposing yourself from 1 to 100?`
        },
        {
            name: alex.properties.instaNickName,
            message: `@GetOutOfMyLab Mmm... 100! 😍`
        },
        {
            name: `Prowl`,
            message: `You can always DM me the uncensored version. I won't tell anybody...`
        },
        {
            name: `mr_officer69`,
            message: `Put your hands up!`
        },
        {
            name: `craig_the_vampire`,
            message: `With the curtains open, lucky neighbors. 😋`
        },
        {
            name: `Harry_Potter`,
            message: `Expelliarmus!`
        },
        {
            name: `Suricat`,
            message: `I think you're safe darling. It's only those pesky nipples they hate. Some dev got bottle-fed when they were a baby!`
        },
        {
            name: `CorprealFale`,
            message: `Lovely! And I hear that if you Photoshop male nipples on it's safe! 😉`
        },
        {
            name: `Sarcasmo`,
            message: `Alex must be green screening, her chair is floating. She'd need to open her legs to prove otherwise`
        },
        {
            name: `Adar`,
            message: `that... that should go to the onlyfans.`
        },
        {
            name: `Spiderman`,
            message: `Holy smeckles. If i weren't in love with you, i would report you! ❤️`
        },
        {
            name: `Tern`,
            message: `Cant you be an angel and send a uncensored version over DM? 😇`
        },
        {
            name: `war`,
            message: `Not to alarm you, but we're about to get robbed, hands up in the air!`
        },
        {
            name: `ruff_ryder`,
            message: `I'm from the middle east so I'll probably be screaming ALLAHU AKBAR when I see that bomb-ass pussy of yours. 👅 `
        },


    ],
    "Alex39": [
        {
            name: alex.properties.instaNickName,
            message: `A dirty girl 🤭 is taking a relaxing bath after a long day 🛀💋💋\nI hope you like my duckie(s) 😜 #bath #nude #ducky #bubbles #tease #hot #dirty #clean`,
        },
        {
            name: `Prowl`,
            message: `The big duckie is very cute. The two little ones however, must be destroyed!`
        },
        {
            name: `GetOutOfMyLab`,
            message: `Rubber ducky quack quack how'd you like that?`
        },
        {
            name: `Ernie`,
            message: `Oh.. rubber duckie, you're the one. You make bath time lots of fun.`
        },
        {
            name: `Spiderman`,
            message: `How? Just how are you taking these pictures, girl? 🤷`
        },
        {
            name: `scooterb`,
            message: `Oh, God. I wish I was a loofah.`
        },
        {
            name: `YougiB`,
            message: `How much for a jar of your bath water ? 🤤`
        },
        {
            name: `ruff_ryder`,
            message: `Why do you waste so much water taking a bath? I could just lick you clean with my tongue 👅`
        },
        {
            name: `Tha_babatunde`,
            message: `In ma village we have water shortage. Your bath water and juices would be a big help for my village. I heard people buy bathwater from models before.`
        },
        {
            name: `fr34k_ofNature`,
            message: `For real though who's the dude taking these pictures? Last post I said I don't envy blind people but I sure do envy that cameraman.`
        },
        {
            name: `marcus_white`,
            message: `remove ducks`,
        },
        {
            name: `bolbol`,
            message: `I have the same ducks. Cute haha`
        },
        {
            name: `Dr.Pancakes`,
            message: `Is this where the term "Lucky Duck" comes from? 😜`
        },
        {
            name: `War`,
            message: `I've got another rubber D you can use...`
        },
        {
            name: `Tern`,
            message: `Sooooo... Does the ducks go "Quack" when you squeeze them? 🤔`
        },
        {
            name: `Alyx`,
            message: `I can't be the only one that squeezes rubber duckies to see if they squeak right?`
        },
        {
            name: `marcus_white`,
            message: `remove ducks`,
        },

    ],
    "Alex38": [
        {
            name: alex.properties.instaNickName,
            message: `I didn't find a frog I could kiss and turn into a prince so I settled for some hot pics 🔥\nWhat do you think? Can I be an amazon girl? 😘🥰 #nature #nude #sexy #hot #tease #hot`,
        },
        {
            name: `Suricat`,
            message: `I'm French, I can be your frog 😉`
        },
        {
            name: `Prowl`,
            message: `Is it just me or would that story had been better if instead of a kiss, a blowjob would have been required?`
        },
        {
            name: `ruff_ryder`,
            message: `I'm actually terrified of frogs but if you wanna be my Tiana I'd be glad to cooperate. `
        },
        {
            name: `ruff_ryder`,
            message: `@Prowl I think there's a clip of your version somewhere on the internet. Might be worth a shot and look for it.`
        },
        {
            name: `Prowl`,
            message: `@ruff_ryder How about as@lil_crazy_alex first Onlyfans Video? Better find a frog costume @suricat`
        },
        {
            name: `Suricat`,
            message: `@Prawl... Ribbit, ribbit...`
        },
        {
            name: `ruff_ryder`,
            message: `@suricat Please stop. I seriously am terrified of these beasts.`
        },
        {
            name: `fr34k_ofNature`,
            message: `I don't envy blind people as they won't be able to witness this MASSIVE beauty I see right now.`
        },
        {
            name: `Dr.Pancakes`,
            message: `@${alex.properties.instaNickName} As your doctor. I recommend you kiss me instead of random frogs. 😜 `
        },
        {
            name: `Alyx`,
            message: `Wasn't expecting to be jealous of a leaf today`
        },
        {
            name: `Spiderman`,
            message: `Holy smeckles. That is some sorroundings I must say`
        },
        {
            name: `Mysterio`,
            message: `if you are looking for frogs, I got plenty in my backyard. Feel free to come`
        },
        {
            name: `Seymour_Butz`,
            message: `Alex makes like a tree, leaves`
        },
        {
            name: `Tern`,
            message: `You be the amazon girl and I will be the explorer that discovers you.. In more ways than one 🤠`
        },
        {
            name: `bolbol`,
            message: `I can pretend to be the frog you kiss if you let me kiss that PUSSY CAT`
        },
        {
            name: `Tha_babatunde`,
            message: `Tha people in my village are thirsty for some wotah, but I am becoming mor thristy for you and your pussy cat.`
        },

    ],
    "Alex37": [
        {
            name: alex.properties.instaNickName,
            message: `I hope you are enjoying the view as much as I am 😘😘😘 #feelingamazing #booty #sexy #hot #view #happy #loved`,
        },
        {
            name: `Suricat`,
            message: `oh yes... Great view indeed... Beautiful moon tonight.`
        },
        {
            name: `Alyx`,
            message: `neighbors must love you for putting on a show looking this hot. Love you Alex!! `
        },
        {
            name: `Spiderman`,
            message: `@TTrick my man, look. This is the girl I talked about. She has some amazing content. I just wish she would make an Onlyfans!`
        },
        {
            name: `Lodar`,
            message: `A kind warning: I know where you live. `
        },
        {
            name: `Suricat`,
            message: `@Addar damn dude, creepy much ? `
        },
        {
            name: `Alyx`,
            message: `@Spiderman I would hop on that in a heartbeat. Alex is such a goddess`
        },
        {
            name: `Dr.Pancakes`,
            message: `@${alex.properties.instaNickName} A view like that is always better shared with another. I nominate my self. 😜 `
        },
        {
            name: `Prowl`,
            message: `It's amazing how a beautiful woman can light up the night. Any chance for a collaboration shoot with @sweet_ann?`
        },
        {
            name: `-Godlike-`,
            message: `what a juicy booty! Want to hang out some time and maybe let me taste a bit of that sweet ass of yours? 😉`
        },
        {
            name: `Alyx`,
            message: `I wonder if @Lodar needs to get put on a watchlist?`
        },
        {
            name: `Suricat`,
            message: `@FBI, I hope you guys got this...`
        },
        {
            name: `Lodar`,
            message: `@Alyx  bitch I am the watchlist.`
        },
        {
            name: `FederalBootieInspector`,
            message: `@suricat Thank you for bringing this to our attention.`
        },
        {
            name: `ruff_ryder`,
            message: `Tell you what, do the 'west side' sign and Imma venmo you 500 buks, a'ight?`
        },
        {
            name: `notorious`,
            message: `Girl you so fine it's a damn crime. Now the FBI is even following you.`
        },
        {
            name: `Lodar`,
            message: `@ruff_ryder , get in the damn line.`
        },
        {
            name: `scooterb`,
            message: `wait! i can see my office from there!`
        },
        {
            name: `real_FBI69`,
            message: `The only crime committed here is being so damn HOT! 🔥`
        },

    ],
    "Alex36": [
        {
            name: alex.properties.instaNickName,
            message: `What do you think about my emojis? 😜 #hot #morning #sexy #tattoo #topless`,
        },
        {
            name: `Suricat`,
            message: `I've said for years now Emojis will be the end of our civilisation...`,
        },
        {
            name: `ruff_ryder`,
            message: `Remove these emojis 'cause my tongue is gonna explore these MOUNTAINS!`,
        },
        {
            name: `Dr.Pancakes`,
            message: `I simultaneously love and hate those emojis. 😳`,
        },
        {
            name: `French4_Rooster`,
            message: `Does the carpet match the emojis?`,
        },
        {
            name: `Addar`,
            message: `You really should move to onlyfans with this kind of content`,
        },
        {
            name: `Tern`,
            message: `Sooo.... Is it possible to get the uncensored version? Pretty please? 🥺`,
        },
        {
            name: `war`,
            message: `Don't like them, Hate them, get rid of them...`,
        },
        {
            name: `Bigboy90`,
            message: `@${alex.properties.instaNickName} I would like to be those 2 emojis  😍 😍`,
        },
        {
            name: `Spider-Man`,
            message: `All I am wondering is who's the lucky guy/girl taking the picture?`,
        },
        {
            name: `teddyruxpin`,
            message: `🧸`,
        },
        {
            name: `scooterb`,
            message: `these emojis would be better 🧊🧊`,
        },
        {
            name: `alexforever`,
            message: `@${alex.properties.instaNickName} i just love your hair back like that! you are so pretty!`,
        },
        {
            name: `scooterb`,
            message: `@${alex.properties.instaNickName} you have such nice eyes - you should show them off more!`,
        },
        {
            name: `BRSTLVR`,
            message: `#freethenipples`,
        },
        {
            name: `ero_sennin`,
            message: `What i would do to be where that plant is!`,
        },
        {
            name: `getoutofmylab`,
            message: `fuggin slut. Love her.`,
        },
        {
            name: `4DoorsMorWhores`,
            message: `😛Wowza`,
        },
        {
            name: `Alyx`,
            message: `why go to a museum when you could look at a piece of art like @lil_crazy_alex`,
        },
        {
            name: `step_on_ME!`,
            message: `WHERE ARE THE HEELS?!?! 😡😡😡`,
        },

    ],
    "Alex35": [
        {
            name: alex.properties.instaNickName,
            message: `Trying to find the best spot to take pictures in my new place!\nMy teddy approves them all 😜 #hot #teddy #panties #new #love`,
        },
        {
            name: `Yougi`,
            message: `How about bent over by the bed or on the wall ? I could take the pictures then 😏`,
        },
        {
            name: `Ruff_Ryder`,
            message: `I want you to sit on my face.`,
        },
        {
            name: `Stew`,
            message: `This is the quality content I follow for.`,
        },
        {
            name: `ruff_ryder`,
            message: `I gonna throw gang signs at yo pussy to let it know I'm about to murder it! WESTSIDE MOTHERFUCKER!!`,
        },
        {
            name: `Dr.pancakes`,
            message: `Teddy doesn't look like a professional. You should show us them all for a second opinion. 😏`,
        },
        {
            name: `AssMaster69`,
            message: `there is only one way to prove this! Show all location in doggy-style 🙂`,
        },
        {
            name: `Dr.Pancakes`,
            message: `☝️ This guy`,
        },
        {
            name: `${alex.properties.instaNickName}`,
            message: `@assmaster69 😉`,
        },
        {
            name: `TheAgent`,
            message: `@${alex.properties.instaNickName} I'm talking to your girl @${ann.properties.instaNickName} - i think i can find you both excellent roles together. DM me pronto`,
        },
        {
            name: `scooterb`,
            message: `@${alex.properties.instaNickName} how much do you love me from 1 to 10? #bearaintgotnothingonme`,
        },
        {
            name: `teddyruxpin`,
            message: `i do indeed approve them and yall are jelly`,
        },
        {
            name: `The_Crooked_Rooster`,
            message: `@theagent Wow, thanks for the heads up on @${ann.properties.instaNickName}. @${alex.properties.instaNickName} , I agree. You two should team up.`,
        },
        {
            name: `${alex.properties.instaNickName}`,
            message: `@scooterb Hmmm...9 💋💋`,
        },
        {
            name: `Prowl`,
            message: `can never fail with two options. 1- Near a mirror that gives us a bonus view of your sexy body. 2- on or around a bed to help fuel our fantasies.`,
        },
        {
            name: `Suricat`,
            message: `how about you take it from my room next time instead ?`,
        },
        {
            name: `red_guy`,
            message: `Don't want to scare you, but that bear seems to be following you`,
        },

    ],
    "Alex34": [
        {
            name: alex.properties.instaNickName,
            message: `Finally finished unpacking 😓\nwhat do you think about my new place??? 💋💋💋\n#new #excited #teddy #hot #pink #love #happy`,
        },
        {
            name: `ruff_ryder`,
            message: `The things I'd do to you in that room GOD DAMNIT!!!😍😍 There's only so much a brother can take before he loses control momma. 😘😤`,
        },
        {
            name: `derrek`,
            message: `counting boobs`,
        },
        {
            name: `assman`,
            message: `I need to switch with this bear ASAP`,
        },
        {
            name: `AssLover6969`,
            message: `lol, fuck it....\nthe room is pretty, but you could live live in a crack-house and everyone would like your photos, because the people want to see only one thing, and that is you sexy Alex 😄😄`,
        },
        {
            name: `ruff_ryder`,
            message: `@assman The bear can watch for all I care, I'll still have my fun.`,
        },
        {
            name: `Dr.Pancakes`,
            message: `After careful consideration, I've decided your room looks great. But you would look better in my room.`,
        },
        {
            name: `scooterb`,
            message: `I enjoy cuddles and am warmer than that bear. #bearaintgotnothingonme`,
        },
        {
            name: `ruff_ryder`,
            message: `@Dr.Pancakes Hi Dr. Nick!`,
        },
        {
            name: `scooterb`,
            message: `show pancakes!`,
        },
        {
            name: `alexforever`,
            message: `@${alex.properties.instaNickName} love those heels! been looking for a pair like that! pls dm where u found them!😘`,
        },
        {
            name: `derrek`,
            message: `4`,
        },
        {
            name: `Stew`,
            message: `Lovely room, when do I get the personal tour?`,
        },
        {
            name: `Yougi`,
            message: `I wish I could be the bear, I know for damn sure you ride it when you're alone ❤️`,
        },
        {
            name: `Prowl`,
            message: `I think  @${alex.properties.instaNickName} is practicing her "O-face" for Tik Thot or onlyfans!`,
        },
        {
            name: `WarDrake`,
            message: `I need a print of that same picture on your wall`,
        },
        {
            name: `tern`,
            message: `I too have the same longing look on my face as that bear right now. If only it was me laying there 🤤`,
        },
        {
            name: `alexforever`,
            message: `OMG!!! i just starting following @${ann.properties.instaNickName} and her taste in footwear is just as fabulous! @${alex.properties.instaNickName} do u both shop at the same place?!?!?`,
        },
        {
            name: `fabfab`,
            message: `I like your bear. Him and I have a lot in common.`,
        },
        {
            name: `teddyruxpin`,
            message: `envy me bitches...this view is incredible! #imthebestbear`,
        },
        {
            name: `war`,
            message: `I don't know, I think I need to get a closer look myself #imyourbear`,
        },
        {
            name: `step_on_ME!`,
            message: `what size of heels are you? 😍`,
        },

    ],
    "Alex33": [
        {
            name: alex.properties.instaNickName,
            message: `Can you believe it's supposed to be advertising for the guitar? 😂 I don't think anyone looks at it 😁 #ad #guitar #sexy #lingerie #purple #hot`,
        },
        {
            name: `ruff_ryder`,
            message: `god you rock that body just like you rock that guitar 🤤`,
        },
        {
            name: `Suri`,
            message: `Oh wow !! What an amazing guitar ! How long have you been playing ?`,
        },
        {
            name: `ferk`,
            message: `Mhm, nice guitar. Need any help with that? We could arrange some private lessons if you're up for it 😏 Hit me up 🙌`,
        },
        {
            name: `scooterb`,
            message: `Where did you get your six string? i got mine at a five and dime.`,
        },
        {
            name: `derrek`,
            message: `boobs`,
        },
        {
            name: `ruff_ryder`,
            message: `@scooterb oh DAMN that's a good one!`,
        },
        {
            name: `Prowl`,
            message: `Play the guitar, they said. You'll get chicks, they said. Why didn't I listen?`,
        },
        {
            name: `Prowl`,
            message: `Ah the "Flaming V." Popular style among metal guitarist of the 80s. Looks like our little Alex may be a rocker!`,
        },
        {
            name: `yougi`,
            message: `Onlyfans when? mommy please reply 🖤❤️`,
        },
        {
            name: `tern`,
            message: ` Oh damn, look at the curves on that guitar, sheeesh! 🤤`,
        },
        {
            name: `AssMaster69`,
            message: `I do not know what I would rather play, the guitar or your horny body 😏`,
        },
        {
            name: `assman`,
            message: `turn around`,
        },
        {
            name: `Dr. Pancakes`,
            message: `Would love to tickle those strings. 😏`,
        },
        {
            name: `war`,
            message: `wanna play with me?`,
        },

    ],
    "Alex32": [
        {
            name: alex.properties.instaNickName,
            message: `can't stay mad at you guys! 😚 thank you for the nice comments!!!\nextra lewd before bed! 💋💋💋\nme and @sophiaa_^ got pierced today!\nshe got it somewhere else! 😳\n\nThank you IN-U for the amazing piercing! 30% off if you say I sent you! (GIRLS ONLY) 🥳\n.\n.\n#ad #AD #Ad #in-u #piercing #pierced #boobies #sexy #randompic #me `,
        },
        {
            name: `dexter`,
            message: `No blood? Impressive healing time... 🙄`,
        },
        {
            name: `sophiaa_^`,
            message: `OMG!!!!! I CAN'T BELIEVE YOU TOLD THEMMMMM 😅`,
        },
        {
            name: `elle_doplpin`,
            message: `stealing my sponsors now?!?`,
        },
        {
            name: `just_a_guy211`,
            message: `hot`,
        },
        {
            name: `marcus_white`,
            message: `no hands`,
        },
        {
            name: `poetixxx`,
            message: `your body is hot, that photo is sick. i can pierce you too, using my dick`,
        },
        {
            name: `yeettt`,
            message: `stop teasing`,
        },
        {
            name: `chasek`,
            message: `sexy!!! 🌹`,
        },
        {
            name: `marcus_white`,
            message: `sexy!!! 🌹`,
        },
        {
            name: `sophiaa_^`,
            message: `my DMs rn -->  🤤`,
        },
        {
            name: `dandan`,
            message: `why didn't you take Ann?`,
        },
        {
            name: `jaskier_of_anywhere`,
            message: `😗`,
        },
        {
            name: `bread_the_blocked`,
            message: `I'm sorry! Please unblock me! 😟`,
        },
        {
            name: `betty_fashionpolice`,
            message: `We approve!`,
        },
        {
            name: `jenn_orange`,
            message: `queen!!! 💗`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@sophiaa_^ haha have fun baby 💋`,
        },
        {
            name: `barista_lena`,
            message: `Lots of sponsors lately, look at you! 😍`,
        },
        {
            name: `philip_screw_you`,
            message: `check DMs`,
        },
        {
            name: `jim_in_the_gym`,
            message: `Adv my gym, check your DMs @${alex.properties.instaNickName}`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@barista_lena 😚`,
        },
        {
            name: `marcus_white`,
            message: `👈 horny @${alex.properties.instaNickName}`,
        },
        {
            name: `keff`,
            message: ` good slut`,
        },
        {
            name: `peek`,
            message: `👀 I see someone at the window`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@marcus_white wow you learn how to tag! 💗`,
        },
        {
            name: `kit_kait`,
            message: `i'll go there i gotta pierce my nipples thxxxx!!! :*`,
        },
        {
            name: `ron`,
            message: `🍆💦`,
        },
        {
            name: `bread_the_blocked`,
            message: `I didn't mean what I said! @${alex.properties.instaNickName}`,
        },
        {
            name: `lily_was_here`,
            message: `I was there and they uploaded my pic to a porn site!!!! beware!`,
        },
        {
            name: `kit_kait`,
            message: `@lily_was_here AWESOME!`,
        },
    ],
    "Alex31": [
        {
            name: alex.properties.instaNickName,
            message: `i'm going to sleep, good night everyone\n\ni get that you guys have needs\nand i know this is how being a model is!!!\nmost of the times i like it\nbut sometimes i want to feel like a lady too😤\n\nthere's more to me than a fap object!!~!\ntell me something about yourself`,
        },
        {
            name: `bread_the_blocked`,
            message: `HEY WHY DID YOU BLOCK ME??`,
        },
        {
            name: `bread_the_blocked`,
            message: `it's bread_the_broken! @${alex.properties.instaNickName} 😢`,
        },
        {
            name: `instagirls<3`,
            message: `simp for you 💗`,
        },
        {
            name: `chasek`,
            message: `sorry`,
        },
        {
            name: `jer_h23`,
            message: `we love you!! 💗`,
        },
        {
            name: `marcus_white`,
            message: `nice boobs`,
        },
        {
            name: `poetixxx`,
            message: `roses are red, violets are blue, but who cares about flowers? please let me fuck you.`,
        },
        {
            name: `dexter`,
            message: `i used to be famous`,
        },
        {
            name: `betty_fashionpolice`,
            message: `like your bra`,
        },
        {
            name: `load_her`,
            message: `i can buy you happiness`,
        },
        {
            name: `snoop_dog991`,
            message: `i like dogs 🐶`,
        },

        {
            name: `peek`,
            message: `you are beautiful!`,
        },

        {
            name: `simp_4ur_nip`,
            message: `🌹🌹🌹`,
        },

        {
            name: `jerry_photography`,
            message: `best model!!! 📸`,
        },

        {
            name: `mark_z`,
            message: `i fap to slutty insta girls`,
        },


        {
            name: `barista_lena`,
            message: `Cutie! 💋`,
        },

        {
            name: `marcus_white`,
            message: `🌹🌹🌹`,
        },


        {
            name: `vinny`,
            message: `😍`,
        },

        {
            name: `jenn_orange`,
            message: `call me @${alex.properties.instaNickName}`,
        },
    ],
    "Alex30": [
        {
            name: alex.properties.instaNickName,
            message: `OK I DON'T KNOW WHY I'M DOING THIS\nbut you guys are soooo nice 🥰\nsecret extas 🥰\n`,
        },

        {
            name: `yeettt`,
            message: `much better pose for you`,
        },

        {
            name: `jerry_photography`,
            message: `WOW! You posted it? One of my top works! 📸`,
        },
        {
            name: `jim_in_the_gym`,
            message: `@jerry_photography nice score man!!!`,
        },


        {
            name: `elle_doplpin`,
            message: `SLUT!!!`,
        },

        {
            name: `red_ned`,
            message: `@jerry_photography how tight was she?`,
        },

        {
            name: `kit_kait`,
            message: `that ass looks inviting! good job baby 💗`,
        },


        {
            name: `dandan`,
            message: `PIC 2 🔥🔥🔥`,
        },
        {
            name: `jerry_photography`,
            message: `I'M JUST THE PHOTOGRAPHER DUDES`,
        },

        {
            name: `jim_in_the_gym`,
            message: `@jerry_photography gay`,
        },
        {
            name: alex.properties.instaNickName,
            message: `this is how modeling looks like!!!`,
        },
        {
            name: `snoop_dog991`,
            message: `say woof`,
        },
        {
            name: `philip_screw_you`,
            message: `@${alex.properties.instaNickName} sure you don't want 🍆?`,
        },
        {
            name: `sophiaa_^`,
            message: `SEXY GODDESS! LOVE YOU 😘`,
        },

        {
            name: `vinny`,
            message: `@${alex.properties.instaNickName} what color are those panties??`,
        },
        {
            name: `keff`,
            message: `sit on my dick`,
        },
        {
            name: `instagirls<3`,
            message: `😍`,
        },

        {
            name: `marcus_white`,
            message: `nice 🍑`,
        },
        {
            name: `brave_dave`,
            message: `babe give me your phone and I swear you wouldn't be able to walk straight for a month`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@vinny BLACK!!! 🤘`,
        },
        {
            name: `vinny`,
            message: `nice can we have a photo without black?`,
        },
        {
            name: `max_`,
            message: `can you deepthroat 8 inches`,
        },
        {
            name: `trevor`,
            message: `I would tear that ass like the mail I got from the IRS`,
        },
        {
            name: `ron`,
            message: `@trevor We need those!`,
        },
        {
            name: `bread_the_broken`,
            message: `STOP WITH THE SEXUAL POSTS!! 😢`,
        },
    ],
    "Alex29": [
        {
            name: alex.properties.instaNickName,
            message: `MY FIRST SET!!! 🥳\nI call it "Shy Angel"! 🥳💞\n<--Shy---- 😇 ----Angel-->\n.\n.\n.\n.\n#photoset #model #sexy #cute #shy #angel #wings #kfc #hungry`,
        },

        {
            name: `chasek`,
            message: `HOT!!! give us more!`,
        },

        {
            name: `gimmie_gimmie_inme`,
            message: `👈 nudes in my story`,
        },
        {
            name: `yeettt`,
            message: `TOO TAME`,
        },
        {
            name: `philip_screw_you`,
            message: `@${alex.properties.instaNickName} hungry for a 🍆?`,
        },

        {
            name: `marcus_white`,
            message: `hey`,
        },

        {
            name: `marcus_white`,
            message: `more`,
        },

        {
            name: alex.properties.instaNickName,
            message: `🤫 @philip_screw_you i know what this means now!! hehe 🤪`,
        },

        {
            name: `jenn_orange`,
            message: `WOW SISTER!`,
        },
        {
            name: `keff`,
            message: `nice books`,
        },
        {
            name: `keff`,
            message: `🤬 auto correct`,
        },
        {
            name: `red_ned`,
            message: `good fap thx`,
        },
        {
            name: `instagirls<3`,
            message: `SEXY!!!`,
        },
        {
            name: `jer_h23`,
            message: `😻!!!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `THX GUYSSSSSSS 💋💋💋!!`,
        },
        {
            name: `peek`,
            message: `Nice set! I call it "Fap Material" 👌`,
        },
        {
            name: `big_hammer`,
            message: `@${alex.properties.instaNickName} sent you something in DMs`,
        },
        {
            name: `marcus_white`,
            message: `more`,
        },

        {
            name: `barista_lena`,
            message: `What a star! 💗`,
        },
    ],
    "Alex28": [
        {
            name: alex.properties.instaNickName,
            message: `getting ready! how do I look? photoshoot soon! 💁‍♀️💗\n.\n.\n.\n#girl #sexy #serious #moody #hot #ass #butt #natural #natural #thot #egirl`,
        },


        {
            name: alex.properties.instaNickName,
            message: `Guys 💋! I'm thinking of selling some extra 🔞 pictures from my sets! 🥰`,
        },

        {
            name: `step_on_ME!`,
            message: `why cut out feet again?!?? 😡😡😡`,
        },
        {
            name: `philip_screw_you`,
            message: `me and 5 other friends would like to join`,
        },
        {
            name: `marcus_white`,
            message: `hi me`,
        },
        {
            name: `marcus_white`,
            message: `hi me too`,
        },
        {
            name: `kit_kait`,
            message: `do it girl!! it's good money! 💞`,
        },
        {
            name: `elle_dolphin`,
            message: `Tryin' to steal my job, bitch? 😤`,
        },
        {
            name: `elle_dolphin`,
            message: `I know where you park 😠`,
        },

        {
            name: `yeettt`,
            message: `@${alex.properties.instaNickName} get naked already`,
        },
        {
            name: `barista_lena`,
            message: `@elle_dolphin BACK OFF BITCH!!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@elle_dolphin i don't even have a car!!!! 😞`,
        },
        {
            name: `dandan`,
            message: `@elle_dolphin is this really you?!`,
        },
        {
            name: `elle_dolphin`,
            message: `@dandan yes! 😊`,
        },
        {
            name: `bread_the_broken`,
            message: `Baby I'm still waiting for you to answer. Why didn't you ask me? I didn't agree to this! They just want to have sex with you...`,
        },
        {
            name: `dandan`,
            message: `@elle_dolphin FU. You gave me herpes.`,
        },
        {
            name: `dexter`,
            message: `stop, dude. just stop.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@bread_the_broken WHO ARE YOU???`,
        },
    ],
    "Alex27": [
        {
            name: alex.properties.instaNickName,
            message: `Metrix and chill?`,
        },
        {
            name: `barista_lena`,
            message: `Lexi are you OK???`,
        },
        {
            name: `dexter`,
            message: `@${alex.properties.instaNickName} are you OK???`,
        },
        {
            name: `jenn_orange`,
            message: `Alex?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `🙄`,
        },
        {
            name: `philip_screw_you`,
            message: `come to CASTING COUCH $$$`,
        },
        {
            name: `chasek`,
            message: `Casting couch at grandmas?? Haha just kidding great couch`,
        },
        {
            name: `load_her`,
            message: `$100 for the Metrix account`,
        },
        {
            name: alex.properties.instaNickName,
            message: `🙄 @philip_screw_you @chasek I don't like casting couch! It looks fake! 😅`,
        },
        {
            name: `load_her`,
            message: `@${alex.properties.instaNickName} $300 for that sofa pillow`,
        },
        {
            name: `marcus_white`,
            message: `hey`,
        },
        {
            name: `marcus_white`,
            message: `i have a real couch`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@load_her ain't mine!`,
        },
        {
            name: `load_her`,
            message: `@${alex.properties.instaNickName} $590 if you spit on it`,
        },
        {
            name: `marcus_white`,
            message: `to @${alex.properties.instaNickName}`,
        },
        {
            name: `marcus_white`,
            message: `to @${alex.properties.instaNickName}`,
        },
        {
            name: `sophiaa_^`,
            message: `@marcus_white DM me 😚`,
        },
    ],
    "Alex26": [
        {
            name: alex.properties.instaNickName,
            message: `It's been a while since you've seen me, so here are two meeeeees!!!!! 😚😚😚\nI miss you, and I love you, waaaaaaaaaaaaaaaaaaaaaahhh.\nhehehe ignore my description, I'm soooooooooo bored rn 😞\nF this already!!!!! Can't wait to go to the beach again! 💋💋💋 from a safe distance!!!!\n\nanyway that's me from both sides!!!\nnot from behind! gotcha!! haha 💗\n.\n.\n.\n.\n#split #imhalf #halfofme #girl #sexy #gamer #gamergirl #nowyouseeme #allnatural #modeling #studio`,
        },
        {
            name: `jenn_orange`,
            message: `@${alex.properties.instaNickName} Beautiful! from all angles! 💋`,
        },
        {
            name: `marcus_white`,
            message: `not good`,
        },
        {
            name: `instagirls<3`,
            message: `My QUEEN is back!`,
        },
        {
            name: `vinny`,
            message: `No boobs, zero ass. What a waste ...`,
        },
        {
            name: `marcus_white`,
            message: `need body too`,
        },
        {
            name: alex.properties.instaNickName,
            message: `😒 @vinny @marcus_white... SOON! 😅`,
        },
        {
            name: `bread_the_broken`,
            message: `@${alex.properties.instaNickName} Good morning my sunshine 💞`,
        },
        {
            name: `step_on_ME!`,
            message: `no feet???`,
        },
        {
            name: `just_a_guy211`,
            message: `SIMP @bread_the_broken 💦`,
        },
        {
            name: `dandan`,
            message: `Great pic!! 🔥`,
        },
        {
            name: `jerry_photography`,
            message: `@${alex.properties.instaNickName} See you soon! 📸`,
        },
        {
            name: `marcus_white`,
            message: `🍆 💦`,
        },
    ],
    "Alex25": [
        {
            name: alex.properties.instaNickName,
            message: `oopsie! you got me! I'm reading your DMs! 😅💞💞 \n#alone #girl #lonely #tooreal #sexy #nude #naked #vodka`,
        },


        {
            name: alex.properties.instaNickName,
            message: `#night #laptop #gamer #body #DMs #reading #love #tipsy`,
        },
        {
            name: `yeettt`,
            message: `Wowwwwwwww`,
        },
        {
            name: alex.properties.instaNickName,
            message: `#pc #table #walls #chair #room #glass #boobs #hair`,
        },
        {
            name: `bread_the_broken`,
            message: `Baby you have to stop! We can't be together if you keep uploading nudes! I love you please stop and answer my DMs. OK? 🌹`,
        },

        {
            name: `marcus_white`,
            message: `@${alex.properties.instaNickName} 🍆🍆🍆`,
        },

        {
            name: `philip_screw_you`,
            message: `@${alex.properties.instaNickName} 🌶🌶`,
        },

        {
            name: `just_a_guy211`,
            message: `🍌🍌🍌`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@marcus_white @philip_screw_you @just_a_guy211 🤤💋`,
        },
        {
            name: alex.properties.instaNickName,
            message: `So many cocks in my inbox ...... 😳`,
        },
        {
            name: `philip_screw_you`,
            message: `@${alex.properties.instaNickName} rate them`,
        },
        {
            name: alex.properties.instaNickName,
            message: `I WANT THEM ALL 🤤🤤🤤`,
        },
        {
            name: `jenn_orange`,
            message: `❓❓❓`,
        },
        {
            name: `barista_lena`,
            message: `@${alex.properties.instaNickName} Is everything OK??? Want me to come?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `noooooooo`,
        },
        {
            name: alex.properties.instaNickName,
            message: `I was drunkkkkk`,
        },
        {
            name: `barista_lena`,
            message: `@${alex.properties.instaNickName} OMFG`,
        },
        {
            name: alex.properties.instaNickName,
            message: `how do I delete???`,
        },
        {
            name: `bread_the_broken`,
            message: `I forgive you 🌹`,
        },

        {
            name: `red_ned`,
            message: `can you type with both hands?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `DELETEEEE 😞`,
        },
    ],
    "Alex24": [
        {
            name: alex.properties.instaNickName,
            message: `come check me out @ Fifthly Greys of Sasha premiere NOW!!! 💋💋 \nthe movie is ok too!\n#FifthlyGreysofSasha #FGOS #movie #premiere #hot #AD #ad #cute #girl #tinystage #sexy #heels #money`,
        },


        {
            name: `snoop_dog991`,
            message: `Can I sniff your armpit? 🐶`,
        },

        {
            name: `jerry_photography`,
            message: `📸 STAR! Call me!`,
        },
        {
            name: `marcus_white`,
            message: `call me`,
        },
        {
            name: `philip_screw_you`,
            message: `turn around!`,
        },

        {
            name: alex.properties.instaNickName,
            message: `@philip_screw_you hehe 😄 come see the movie first!😚`,
        },
        {
            name: `marcus_white`,
            message: `no turn around`,
        },

        {
            name: `sophiaa_^`,
            message: `Not gonna lie, that movie made me kinda wet... ;)`,
        },
        {
            name: `jenn_orange`,
            message: `@sophiaa_^ EWWWWWWW I was there with you!!!`,
        },
        {
            name: `kit_kait`,
            message: `Are they looking for more slutty girls??? Help a sis out I need work! 💗`,
        },


        {
            name: `load_her`,
            message: `$200 for the tiny stage.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@load_her IT'S NOT MINE!😂`,
        },
        {
            name: `load_her`,
            message: `$300.`,
        },


        {
            name: `dominic_movie_critic`,
            message: `Here's my unbiased review of Fifthly Greys of Sasha #FGOS.\nI'm a huge fan of romance movies and let me tell you - FGOS is a huge pile of waste of time! 1/4`,
        },

        {
            name: `dominic_movie_critic`,
            message: `This movie, and indeed the book, is NOT about BDSM. This movie is about nothing but abuse, non-consent, and even has a scene that is nothing but rape and grape. Oh and trust me, they were unripe 2/4`,
        },

        {
            name: `dominic_movie_critic`,
            message: `Honestly, I hated this movie. I know what you're thinking: "All guys just like seeing people have kinky sex on the big screen." No, I don't. I have porn for that. Also, my penis is very tired nowadays. 3/4`,
        },

        {
            name: `dominic_movie_critic`,
            message: `Plot: 1/10. Guess what? The cable guy came. What a surprise. Romance; 2/10. He did let her reach climax once. Honestly, it was very nice of him.  Camera; 10/10. Amazing scenery. I'd fap to it any day 4/4`,
        },
        {
            name: `dominic_movie_critic`,
            message: ` By the way my name is Dominic and I'm working on my first movie. You should follow me! 5/4`,
        },

        {
            name: `dexter`,
            message: `@dominic_movie_critic STFU man we just want to see her naked`,
        },

        {
            name: `bread_the_broken`,
            message: `@dominic_movie_critic Even I'm not that dumb...`,
        },
    ],
    "Alex23": [
        {
            name: alex.properties.instaNickName,
            message: `I'm a rebel 😏 \n#cute #girl #notaselfie #wall #floor #sexy #lingerie #thigh #tight #heels`,
        },

        {
            name: `poetixxx`,
            message: `roses are red, violets suck, i hope that you too`,
        },
        {
            name: `agentx`,
            message: `I've seen you in my dream!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@agentx wow! what did I do there?? 😳`,
        },
        {
            name: `jenn_orange`,
            message: `ANGELIC! 💗🥳💗`,
        },
        {
            name: `agentx`,
            message: `@${alex.properties.instaNickName} Take it from behind`,
        },
        {
            name: `betty_fashionpolice`,
            message: `@${alex.properties.instaNickName} Improving! 😉`,
        },
        {
            name: `marcus_white`,
            message: `hey`,
        },
        {
            name: `marcus_white`,
            message: `@${alex.properties.instaNickName} hey`,
        },
        {
            name: `bread_the_broken`,
            message: `@${alex.properties.instaNickName} my love thank you for making my day!`,
        },
        {
            name: `pharrell`,
            message: `i'm happy`,
        },
        {
            name: `sophiaa_^`,
            message: `beautiful! 💗`,
        },
        {
            name: `chasek`,
            message: `You need some dicks there`,
        },
    ],
    "Alex22": [
        {
            name: alex.properties.instaNickName,
            message: `long day ... empty bed 😞💔 cuddle me 🥰\n#foreveralone #alone #girl #lonely #tooreal #cuddles #selfie #wall #floor #sexy #lingerie`,
        },


        {
            name: alex.properties.instaNickName,
            message: `Send me selfies! I'm bored 💋`,
        },
        {
            name: `simpleman`,
            message: `do you have some pics with white stuff on your face?`,
        },
        {
            name: `just_a_guy211`,
            message: `cuddle my cock ✊✊✊`,
        },
        {
            name: `barista_lena`,
            message: `sexy! 💋`,
        },
        {
            name: alex.properties.instaNickName,
            message: `guys stop sending me dick picssssss 😤`,
        },

        {
            name: `bread_the_broken`,
            message: `Don't send her dicks!!!`,
        },

        {
            name: `sophiaa_^`,
            message: `Wow, fucking perverts... my DMs are open 🙄`,
        },
        {
            name: `jaskier_of_anywhere`,
            message: `toss a coin to your hooker`,
        },

        {
            name: `keff`,
            message: `@${alex.properties.instaNickName} You know you want them 🍌...`,
        },
        {
            name: `dandan`,
            message: `check your DMs`,
        },
        {
            name: `marcus_white`,
            message: `@${alex.properties.instaNickName} sent 5`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@keff 😞`,
        },
        {
            name: `poetixxx`,
            message: `roses are red, your lingerie is black, please let me fuck you from the back`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@poetixxx well... since you asked so nicely 😂`,
        },
    ],
    "Alex21": [
        {
            name: alex.properties.instaNickName,
            message: `NEW HERMISH CHAIR 😳😳😳!! I love it! 😚\n#AD #ad #Ad #hermishchair #girl #sexy`,
        },


        {
            name: `drunk_clown_boozo`,
            message: `if you're happy and you know it clap your hands @${alex.properties.instaNickName}`,
        },
        {
            name: `ASCII`,
            message: `I'm more into tables 🙃`,
        },

        {
            name: `yeettt`,
            message: `@${alex.properties.instaNickName} you can sit on my chair`,
        },
        {
            name: `step_on_ME!`,
            message: `Let me suck your toes`,
        },
        {
            name: `marcus_white`,
            message: `@${alex.properties.instaNickName} sit on my dick`,
        },
        {
            name: `dandan`,
            message: `Who else is excited for cyberpunk?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@marcus_white 🙄... can we talk first? 😚`,
        },
        {
            name: `vinny`,
            message: `move your hands we're here for one thing`,
        },

        {
            name: `jer_h23`,
            message: `can i get a piece of your hair???? even just a strand will be fine!!`,
        },
        {
            name: `load_her`,
            message: `$600 for the carpet.`,
        },
        {
            name: `pharrell`,
            message: `@drunk_clown_boozo i'm happy`,
        },
        {
            name: `load_her`,
            message: `$700 if you grind on it in a video.`,
        },
    ],
    "Alex20": [
        {
            name: alex.properties.instaNickName,
            message: `trying this out 😳 i'm selling those👉👙 DM me...\n#girl #lingerie #sexy #selling`,
        },


        {
            name: alex.properties.instaNickName,
            message: `worn for a day... 😇`,
        },
        {
            name: `h1sst`,
            message: `nice`,
        },
        {
            name: `ricehard`,
            message: `WOW slut`,
        },
        {
            name: `jenn_orange`,
            message: `Take care 💗💗💗`,
        },

        {
            name: `load_her`,
            message: `$200.`,
        },
        {
            name: `gogsy1`,
            message: `Such a hot babe 🔥🔥🔥`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@load_her Yay! DM me! 💋`,
        },
        {
            name: `load_her`,
            message: `$350 final.`,
        },

        {
            name: `dis39`,
            message: `😷`,
        },
        {
            name: `marcus_white`,
            message: `hey`,
        },

        {
            name: `step_on_me`,
            message: `I can't see your shoes`,
        },

        {
            name: `bread_the_broken`,
            message: `You don't need to sexualize yourself, you are a pretty girl! If you have trouble at home please contact me and we can talk 💗`,
        },
        {
            name: `keff`,
            message: `@${alex.properties.instaNickName} video too?`,
        },
        {
            name: `marcus_white`,
            message: `bread_the_broken stop`,
        },
        {
            name: `jaskier_of_anywhere`,
            message: `toss a coin to your alexxxx`,
        },
    ],
    "Alex19": [
        {
            name: alex.properties.instaNickName,
            message: `This view is amazing 🌞🌞🌞 #beach`,
        },

        {
            name: `yeettt`,
            message: `YES IT IS 🍆 💦`,
        },
        {
            name: `bread_the_broken`,
            message: `@${alex.properties.instaNickName}, I know we don't talk much. Well, you never even responded to my DMs. I just want you to know that you are the highlight of my day. I wake up everyday craving another one of your posts. I know we would make a great couple. Can't seem to get over you and your beautiful body. Please, can we talk? Love you 🌹`,
        },
        {
            name: `marcus_white`,
            message: `i just want to fuck you 🌹`,
        },
        {
            name: `bread_the_broken`,
            message: `@${alex.properties.instaNickName}, I wasn't in-love with you at first. But, suddenly, without reason, after 8 seasons I decided that I am!`,
        },
        {
            name: `bread_the_broken`,
            message: `I mean 8 posts.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@bread_the_broken Never had someone try so hard to get into my panties 😅`,
        },
        {
            name: `yeettt`,
            message: `@bread_the_broken virgin`,
        },
        {
            name: `red_ned`,
            message: `love your ass`,
        },
        {
            name: `philip_screw_you`,
            message: `💯 view`,
        },
        {
            name: `barista_lena`,
            message: `@bread_the_broken 😂💗`,
        },
        {
            name: `chasek`,
            message: `hey babe`,
        },
        {
            name: `jerry_photography`,
            message: `📸 We need to meet again.`,
        },
    ],
    "Alex18": [
        {
            name: alex.properties.instaNickName,
            message: `Night out! Dancing at the bar! Can't even remember it's name 😂 #bar #dancing #club #fun`,
        },

        {
            name: `${ann.properties.instaNickName}`,
            message: `I think we were at the same place.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@${ann.properties.instaNickName} REALLY???? I DIDN'T SEE YOUUUU! 😭😭😭`,
        },

        {
            name: `instagirls<3`,
            message: `🔥🔥🔥`,
        },

        {
            name: `yeettt`,
            message: `sent you a DM`,
        },

        {
            name: `just_a_guy211`,
            message: `didn't recognize you with clothes`,
        },
        {
            name: `load_her`,
            message: `$100 for the panties if you sweat in it.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@load_her NO! 😒`,
        },
        {
            name: `load_her`,
            message: `$150`,
        },
        {
            name: `bread_the_broken`,
            message: `MERRY ME 💗`,
        },
        {
            name: `marcus_white`,
            message: `where`,
        },
        {
            name: `philip_screw_you`,
            message: `DM me my 🍆 is huge`,
        },
        {
            name: `sophiaa_^`,
            message: `call me next time! 💋`,
        },
    ],
    "Alex17": [
        {
            name: alex.properties.instaNickName,
            message: `Feeling frisky :3`,
        },
        {
            name: `marcus_white`,
            message: `clap your hands`,
        },
        {
            name: `poetixxx`,
            message: `roses are red. your towel is not. give me your number, you sexy thot 🤤`,
        },
        {
            name: `instagirls<3`,
            message: `@poetixxx dude, wtf?`,
        },
        {
            name: `just_a_guy211`,
            message: `before or after 🚿?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@just_a_guy211 After! 😛`,
        },
        {
            name: `poetixxx`,
            message: `roses are red. my balls are blue. why do you ignore me, you stupid hoe.`,
        },
        {
            name: `sniffurry`,
            message: `WOW can i smell your towel??`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@poetixxx 😐😐😐❗`,
        },
        {
            name: `dexter`,
            message: `@${alex.properties.instaNickName} Hey, I can help you with that.`,
        },
        {
            name: `barista_lena`,
            message: `@poetixxx fuck you 🤧. Just block him.`,
        },
        {
            name: `load_her`,
            message: `$70 for that towel if you don't wash it.`,
        },
        {
            name: `red_ned`,
            message: `do you sell bath water??`,
        },
    ],
    "Alex16": [
        {
            name: alex.properties.instaNickName,
            message: `@jerry_photography 📸 agreed to take my pictures for free! Thanks Jerry!💗`,
        },
        {
            name: `jerry_photography`,
            message: `No problem! You're a great model! 😉`,
        },
        {
            name: `chasek`,
            message: `of course he did...`,
        },
        {
            name: `jenn_orange`,
            message: `Wow girl, brave! 😈`,
        },
        {
            name: `philip_screw_you`,
            message: `i wonder why...`,
        },
        {
            name: `marcus_white`,
            message: `more`,
        },
        {
            name: `barista_lena`,
            message: `You are INSANE!!!! 😳😳😳`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@barista_lena 😇`,
        },
        {
            name: `just_a_guy211`,
            message: `more pls`,
        },
        {
            name: `dandan`,
            message: `What did he get in return? 😉`,
        },

        {
            name: `diver_willy`,
            message: `Hi, I can give you diving lessons once im free! 🐬`,
        },

        {
            name: `bread_the_broken`,
            message: `LOVE YOU 💗`,
        },

        {
            name: `jer_h23`,
            message: `yo you are fire`,
        },

        {
            name: `dexter`,
            message: `@${alex.properties.instaNickName} I have a boat. You are invited.`,
        },
    ],
    "Alex15": [
        {
            name: alex.properties.instaNickName,
            message: `Finally got my first gig! 🥳 I'm @ the annual car show during the weekend come say hi! 🙋‍♀️ #modeling #AD`,
        },

        {
            name: `kit_kait`,
            message: `Loved working with you BB! 💗 see you soon 💋`,
        },
        {
            name: `vinny`,
            message: `star of the show!!!`,
        },
        {
            name: `marcus_white`,
            message: `that's my car`,
        },
        {
            name: `chasek`,
            message: `Yo, check my ride`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@kit_kait Thxxxxxxx 😇 You are amazing! 😘`,
        },
        {
            name: `marcus_white`,
            message: `@${alex.properties.instaNickName} hey`,
        },
        {
            name: `betty_fashionpolice`,
            message: `@${alex.properties.instaNickName} 👠❌ That's a no-no!`,
        },
        {
            name: `step_on_ME!`,
            message: `@betty_fashionpolice I approve!`,
        },
        {
            name: `dandan`,
            message: `Hello beautiful 👌`,
        },
        {
            name: `barista_lena`,
            message: `OMG! I'm a fan! 😍😍😍`,
        },
        {
            name: `sophiaa_^`,
            message: `do they need more girls there? i'm in!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@sophiaa_^ call me!`,
        },

        {
            name: `instagirls<3`,
            message: `WOWWW 🔥🔥🔥`,
        },

        {
            name: `yeettt`,
            message: `SEXY!!! sent you a DM`,
        },

        {
            name: `just_a_guy211`,
            message: `SICK RIDE 🍑`,
        },
    ],
    "Alex14": [
        {
            name: alex.properties.instaNickName,
            message: `Guys! If you want another photo Just ask for it in the comments and maybe I'll send it to you! 😘 #tanning #body #summer`,
        },

        {
            name: `barista_lena`,
            message: `Omg I can't believe you uploaded this!!!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@barista_lena IKR! 😂`,
        },
        {
            name: `marcus_white`,
            message: `send`,
        },
        {
            name: `yeettt`,
            message: `Damn fine sexy bitch!!! I would love to get the other photo`,
        },
        {
            name: `chasek`,
            message: `Hey please send me the photo`,
        },
        {
            name: `dandan`,
            message: `Send me!!`,
        },
        {
            name: alex.properties.instaNickName,
            message: `LOL you guys are the best 😘`,
        },
        {
            name: `marcus_white`,
            message: `send`,
        },
        {
            name: `jim_in_the_gym`,
            message: `Great body but I can make it better. DM me.`,
        },
        {
            name: `jer_h23`,
            message: `Holy shit where did you come from??`,
        },
    ],
    "Alex13": [
        {
            name: alex.properties.instaNickName,
            message: `Celebrating my workout with an ice cream! 😌 #Icecream #Happy #Sun #Life`,
        },
        {
            name: `barista_lena`,
            message: `You go girl! I always said you don't need to workout at all!! 🍑`,
        },
        {
            name: `jim_in_the_gym`,
            message: `That's not effective at all...`,
        },
        {
            name: `marcus_white`,
            message: `lick ice cream`,
        },
        {
            name: `dandan`,
            message: `Where is it?`,
        },
    ],
    "Alex12": [
        {
            name: alex.properties.instaNickName,
            message: `PUPPYYYY!!!! #Puppy #Dog #Cute #Happy #Park`,
        },

        {
            name: `chasek`,
            message: `Cute puppy, is it yours?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@chasek I wish... Someone at the park let me take a picture with it`,
        },
        {
            name: `marcus_white`,
            message: `cool dog`,
        },
        {
            name: `marcus_white`,
            message: `ugly dog`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@marcus_white You're ugly! 😑🤣`,
        },
        {
            name: `snoop_dog991`,
            message: `That's my son 👍`,
        },
    ],
    "Alex11": [
        {
            name: alex.properties.instaNickName,
            message: `Just me at the park. #Park #Posing #Happy`,
        },

        {
            name: `barista_lena`,
            message: `@${alex.properties.instaNickName} Who took all those photos??`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@barista_lena A friend :) 😘`,
        },
        {
            name: `marcus_white`,
            message: `i'm a friend`,
        },
        {
            name: `marcus_white`,
            message: `hey`,
        },
        {
            name: `chasek`,
            message: `Just me getting hard #Happy`,
        },
    ],
    "Alex10": [

        {
            name: alex.properties.instaNickName,
            message: `Push ups at the park! 😘 #Pushups #Park #Workout`,
        },


        {
            name: `barista_lena`,
            message: `Damn girl!! Looking good!`,
        },

        {
            name: alex.properties.instaNickName,
            message: `😘 😘 😘`,
        },

        {
            name: `just_a_guy211`,
            message: ` What park is it?`,
        },

        {
            name: `marcus_white`,
            message: `hey`,
        },

        {
            name: `sophiaa_^`,
            message: `OMG sis, dat ass 😉`,
        },

        {
            name: `step_on_ME!`,
            message: `Nice sneakers`,
        },

        {
            name: `dandan`,
            message: `Squats are really paying off.`,
        },
    ],
    "Alex9": [
        {
            name: alex.properties.instaNickName,
            message: `The gym is boring so I went jogging!😀 👞👞👞 #Jogging #Sun #Workout`,
        },

        {
            name: `yeettt`,
            message: `Why are you wearing the same shirt from your house?`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@yeettt It's my workout shirt!!!`,
        },
        {
            name: `marcus_white`,
            message: `take it off`,
        },
        {
            name: `step_on_ME!`,
            message: `Walk on my face`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@step_on_ME! 🙄 Whatever floats your boat 👠😘`,
        },
    ],
    "Alex8": [
        {
            name: alex.properties.instaNickName,
            message: `Look at what I found on the way to the pool! Annie 😘 #BFF #Besties`,
        },

        {
            name: `barista_lena`,
            message: `Awwwwww 😚`,
        },
        {
            name: `sophiaa_^`,
            message: `Haha, I didn't know you two were friends! Cute ;)`,
        },
        {
            name: `chasek`,
            message: `Who she??`,
        },
        {
            name: `yeettt`,
            message: `Two bitches better than one.`,
        },
        {
            name: alex.properties.instaNickName,
            message: `@sophiaa_^ Ofc we are!`,
        },
        {
            name: `dandan`,
            message: `Hey, I know that girl!`,
        },
    ],
    "Alex7": [
        {
            name: alex.properties.instaNickName,
            message: `Bottom! 😚😚 OMG perverts 😛`
        },

        {
            name: alex.properties.instaNickName,
            message: `@marcus_white Happy??? 😂👉💦`
        },
        {
            name: `jerry_photography`,
            message: `You have great potential. DM me if you are interested in a photo shoot.`
        },
        {
            name: alex.properties.instaNickName,
            message: `@jerry_photography Thanks! I'm poor 😞`
        },
        {
            name: `marcus_white`,
            message: `turn`
        },
        {
            name: `jerry_photography`,
            message: `No worries. Let's talk.`
        },
        {
            name: `jenn_orange`,
            message: `Cute set! Where did you get it? 😚`
        },
        {
            name: `bread_the_broken`,
            message: `Hi, sent you a DM.`
        },
        {
            name: `chasek`,
            message: `Sent you a DM.`
        },
        {
            name: `yeettt`,
            message: `Check your DMs.`
        },
        {
            name: alex.properties.instaNickName,
            message: `You guys stopppppppppp 😂😂😂`
        },
        {
            name: `barista_lena`,
            message: `Haha, what did you expect? 😘`
        },
        {
            name: `step_on_ME!`,
            message: `Can you step on my face??`
        },
    ],
    "Alex6": [
        {
            name: alex.properties.instaNickName,
            message: `Back from the gym. Time to show off! Hehe, see you at the pool! #LifeGuardLove😍 😎😎😎`
        },
        {
            name: `jenn_orange`,
            message: `So hotttt! 😍😍`
        },
        {
            name: `barista_lena`,
            message: `Haha naughty girl! love ya 💋`
        },
        {
            name: `sophiaa_^`,
            message: `Lifeguards 😚😚😚 Can I come?`
        },
        {
            name: `marcus_white`,
            message: `show bottom`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },
        {
            name: alex.properties.instaNickName,
            message: `@marcus_white prev 😂`
        },
        {
            name: `yeettt`,
            message: `@marcus_white Agreed.`
        },
        {
            name: `marcus_white`,
            message: `show bottom`
        },
        {
            name: alex.properties.instaNickName,
            message: `@marcus_white @yeettt Ok fineeeeeeeee 🙃😘`
        },
        {
            name: `chasek`,
            message: `@marcus_white +1`
        },
    ],
    "Alex5": [
        {
            name: alex.properties.instaNickName,
            message: `Going to the gym is starting to payoff! #gym #NoPainNoGain #abs 👊😄`
        },

        {
            name: `chasek`,
            message: `Always wanted to fuck the girl with the dragon tattoo but I'd settle for the flower tattoo...`
        },

        {
            name: alex.properties.instaNickName,
            message: `😂😂😂`
        },

        {
            name: `barista_lena`,
            message: `@chasek Epic 🤣`
        },
        {
            name: `yeettt`,
            message: `HOT AF`
        },
        {
            name: `bread_the_broken`,
            message: `Such a beauty 😘`
        },
        {
            name: `instagirls<3`,
            message: `Sexy.`
        },

    ],
    "Alex4": [
        {
            name: `${alex.properties.instaNickName}`,
            message: `Started doing squats at the gym! #gym #NoPainNoGain #life 🍑💯😌`
        },
        {
            name: `step_on_ME!`,
            message: `HEY 😚 show feet`
        },
        {
            name: `step_on_ME!`,
            message: `Please`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },
        {
            name: `chasek`,
            message: `Lookin' sweet. slide you a DM??`
        },
        {
            name: `${alex.properties.instaNickName}`,
            message: `@chasek Nope 😛`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },
        {
            name: `marcus_white`,
            message: `good ass`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },
        {
            name: `${alex.properties.instaNickName}`,
            message: `@marcus_white Thank you.`
        },
        {
            name: `marcus_white`,
            message: `take it from behind??    `
        }

    ],
    "Alex3": [
        {
            name: alex.properties.instaNickName,
            message: `That's how I look every morning! #Honest 😂`
        },
        {
            name: `marcus_white`,
            message: `cute 😍`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },
        {
            name: `marcus_white`,
            message: `show boobs`
        },
        {
            name: `bread_the_broken`,
            message: `@marcus_white Wrong site dude...`
        },
        {
            name: `marcus_white`,
            message: `?`
        },
        {
            name: `barista_lena`,
            message: `Ha! That's why you were late today 😉`
        },

    ],
    "Alex2": [
        {
            name: alex.properties.instaNickName,
            message: `My tattoooo! #Tattoo #Tummy #Home #Selfie 😊😊😊`
        },
        {
            name: `jenn_orange`,
            message: `hehe lookin' good sis!! 😍😍`
        },
        {
            name: `barista_lena`,
            message: `Hey love! We should go shopping soon!`
        },
        {
            name: alex.properties.instaNickName,
            message: `@jenn_orange @barista_lena 😚😚💕`
        },
        {
            name: `marcus_white`,
            message: `hey`
        },

    ],
    "Alex1": [
        {
            name: alex.properties.instaNickName,
            message: `So I finally decided to Check Insta! xoxo #FirstPicture #Home #Summer 😋`
        }
    ],

};